<template>
	<div :class="['reply-top-bar', item.del === '1' ? 'del' : '']">
		<div class="info-l f-cb" v-if="item.del !== '1'">
			<div class="from f-fl f-toe1">
				<span class="addr" v-if="item.area">{{item.area}}</span>{{item.userName}}
			</div>
			<div class="to">
				<em>回复：</em>{{item.replyTo}}
			</div>
		</div>
		<div class="info-r">
			<span class="floor">{{item.floor}}楼</span>
		</div>
	</div>
</template>

<script>
export default {
	props: ['item']
}
</script>


// WEBPACK FOOTER //
// reply-top-bar.vue?1a465de2